// extracted by mini-css-extract-plugin
export default {"block":"wl","select":"xl","empty":"yl","open":"zl","error":"Al","options":"Bl","selectActive":"Cl","ornament":"Dl"};